// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateAuthorizedUserDto
 */
export interface ICreateAuthorizedUserDto {
    /**
     * 
     * @type {number}
     * @memberof ICreateAuthorizedUserDto
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateAuthorizedUserDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateAuthorizedUserDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateAuthorizedUserDto
     */
    relationship_type: ICreateAuthorizedUserDtoRelationshipTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ICreateAuthorizedUserDto
     */
    birth_on: Date;
}

/**
* @export
* @enum {string}
*/
export enum ICreateAuthorizedUserDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the ICreateAuthorizedUserDto interface.
 */
export function instanceOfICreateAuthorizedUserDto(value: object): value is ICreateAuthorizedUserDto {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('relationship_type' in value) || value['relationship_type'] === undefined) return false;
    if (!('birth_on' in value) || value['birth_on'] === undefined) return false;
    return true;
}

export function ICreateAuthorizedUserDtoFromJSON(json: any): ICreateAuthorizedUserDto {
    return ICreateAuthorizedUserDtoFromJSONTyped(json, false);
}

export function ICreateAuthorizedUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateAuthorizedUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'relationship_type': json['relationship_type'],
        'birth_on': (new Date(json['birth_on'])),
    };
}

export function ICreateAuthorizedUserDtoToJSON(json: any): ICreateAuthorizedUserDto {
    return ICreateAuthorizedUserDtoToJSONTyped(json, false);
}

export function ICreateAuthorizedUserDtoToJSONTyped(value?: ICreateAuthorizedUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'relationship_type': value['relationship_type'],
        'birth_on': ((value['birth_on']).toISOString().substring(0,10)),
    };
}

